import { createApp } from '@app/adapters/create-app'

import ReportGraphsDrawerToggle from '@app/application/report/components/report-graphs-drawer-toggle.vue'

window.onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='report-graphs-drawer-toggle']").each(function () {
    createApp(ReportGraphsDrawerToggle, {}).mount(this)
  })
})
